import { defineComponent } from 'vue'
import './style.sass'

export default defineComponent({
  props: {
    placeholder: {
      type: String,
      default: () => 'Поиск по сайту'
    },
    styleClass: {
      type: String,
      default: () => 'red'
    },
    onInput: {
      type: Function,
      default: (value: number) => { return value }
    }
  },

  setup (props: any) {
    function getSearchValue (e: any) {
      props.onInput(e)
    }

    return () => {
      return (
        <div class={`search ${props.styleClass}`}>
          <input
            tabindex="1"
            type="search"
            name="q"
            placeholder={props.placeholder}
            autocomplete="off"
            class={`${props.styleClass}`}
            onInput={(e) => getSearchValue(e)}
          />
        </div>
      )
    }
  }
})